export default {
    'name': 'quotation',
    'width': '64',
    'height': '64',
    'viewBox': '0 0 64 64',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M0 8H6.483H29.9095L13.0443 55.2445H6.483V30.7218H0V8ZM34.0905 8H40.5735H64L47.1348 55.2445H40.5735V30.7218H34.0905V8Z\' fill=\'#026958\'/>'
}
